import React from "react";
import styles from "./index.module.css";
import checkMark from "../../assets/images/checkmark--filled-purple.svg";
import mockMode from "../../assets/images/case-select-practice-mode-purple.svg";
import practiceMode from "../../assets/images/case-select-practice-mode.svg";

interface ModeSwitcherProps {
  mode: "mock" | "practice";
  setMode: React.Dispatch<React.SetStateAction<"mock" | "practice">>;
}

export default function ModeSwitcher({ mode, setMode }: ModeSwitcherProps) {
  return (
    <div>
      {/* Mode Title */}
      <h1 className="text-lg font-bold text-text-primary mb-4 px-2">Mode</h1>

      <div className={styles.modeGrid}>
        {/* Mock Mode Card */}
        <div
          onClick={() => setMode("mock")}
          className={`bg-[#F5F6F7] p-4 rounded-lg ${
            mode === "mock"
              ? `${styles.modeCard} ${styles.modeCardActive}`
              : `${styles.modeCard} ${styles.modeCardInactive}`
          }`}
        >
          <div className="flex items-center">
            {/* Left side with icon and title */}
            <img
              src={mockMode}
              alt="Mock Mode Logo"
              className="w-16 h-16 mr-2 [&>path]:fill-primary"
            />

            {/* Description aligned with title */}
            <div className="ml-4">
              <div className="flex items-center mr-2">
                <h2 className="text-lg font-500">Mock</h2>
              </div>
              <p className="text-gray-600 text-sm">
                Get the real interview feel, complete with lifelike interactions
                and feedback. No pressure, just results.
              </p>
            </div>
            {mode === "mock" && (
              <img src={checkMark} className="ml-auto text-primary" />
            )}
          </div>
        </div>

        {/* Practice Mode Card (Coming Soon) */}
        <div className={`bg-[#F5F6F7] p-4 rounded-lg ${styles.comingSoonCard}`}>
          <div className="flex items-center">
            {/* Left side with icon and title */}
            <img
              src={practiceMode}
              alt="Practice Mode Logo"
              className="w-16 h-16 mr-4"
            />

            {/* Description aligned with title */}
            <div>
              <h2 className="text-lg font-500">Practice (Coming Soon)</h2>
              <p className="text-gray-600 text-sm">
                A stress-free space to improve your skills step by step at your
                own pace. Perfect for practice and learning.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
